module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.2.0 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/actionsheet.html"
    }
  }, [_vm._v("Actionsheet")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Donot update handel z-index in Safari when using v-transfer-dom")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/alert.html"
    }
  }, [_vm._v("Alert")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add prop:content")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/button-tab.html"
    }
  }, [_vm._v("ButtonTab")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Update border style(1px)")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/cell-form-preview.html"
    }
  }, [_vm._v("CellFormPreview")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] new component")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/cell.html"
    }
  }, [_vm._v("Cell")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support prop:is-loading")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/datetime-range.html"
    }
  }, [_vm._v("DatetimeRange")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Use better column width")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] render picker on nextTick #1180")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/grid.html"
    }
  }, [_vm._v("Grid")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support dynamic rows")]), _vm._v(" "), _c('li', [_vm._v("[enhance] Hide slot:icon and slot:label if not being set")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/scroller.html"
    }
  }, [_vm._v("Scroller")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix issue when redirecting on scrolling #1187")]), _vm._v(" "), _c('li', [_vm._v("[fix] Fix resize listener not being destroyed #1183")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/search.html"
    }
  }, [_vm._v("Search")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] emit on-change after input")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/swipeout.html"
    }
  }, [_vm._v("Swipeout")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix cannot scroll when disabled")]), _vm._v(" "), _c('li', [_vm._v("[fix] Fix unable to trigger click event when disabled on android")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-address.html"
    }
  }, [_vm._v("XAddress")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Upgrade datas #1101")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-icon.html"
    }
  }, [_vm._v("XIcon")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Support all attributes #1147")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/transfer-dom.html"
    }
  }, [_vm._v("TransferDom")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Support simple entry name: TransferDom")]), _vm._v(" "), _c('li', [_vm._v("[enhance] Add classname v-transfer-dom")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9ab3682c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-9ab3682c"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.2.0-90.vue
// module id = 2403
// module chunks = 330